import { useContext, useEffect, useState } from "preact/hooks";
import { eventDays } from "src/isf-2025/assets";
import { DayContext } from "src/isf-2025/contexts/DayContext";
import { DisplayAlways, DisplayOnce } from "src/utils/fw";

export default function TimedPopups(props) {

    // DEBUG TOOLS
    const context = useContext(DayContext)

    function getActive(force) {
        const now = force || new Date().getTime()
        const res = props.days?.filter(it => {
            if (it.always) return true;

            if (it.start && it.start.getTime() <= now) {

                if (!it.end) return true

                return it.end.getTime() > now
            }

            return !it.start && it.end && it.end.getTime() > now
        }) || []
        return res
    }

    const [debugDay, setDD] = useState(context.date.day)
    const [active, setActive] = useState(getActive())

    if (context.date.day !== debugDay) {
        setActive(getActive(context.date?.day !== null ? eventDays[context.date?.day].getTime() : undefined))
        setDD(context.date.day)
    }

    const current = active.length > 0 ? active[0] : null

    if (!current) return <></>

    const texts = current.text.map((text, idx) => {
        if (idx === 0) { //title
            return <h6 style={{marginBlock: "1em", fontSize: "xx-large"}}>{text}</h6>
        }

        return <span style={{display: "block", fontSize: "1.1em", marginBottom: "2em"}}>{text}</span>
    })

    if (current.displayOnce) return <DisplayOnce key={current.name} id={current.name} onClose={() => {
        const [ignore, ...popups] = active
        setActive(popups)
    }} dismissHTML="X" style={{
        color: "white",
        textAlign: "center",
        maxWidth: "800px"
    }}>
        {texts}
    </DisplayOnce>

    return <DisplayAlways id={current.name}>{texts}</DisplayAlways>
}